import script from "./cst_v1_assessment.vue?vue&type=script&setup=true&lang=js"
export * from "./cst_v1_assessment.vue?vue&type=script&setup=true&lang=js"

import "./cst_v1_assessment.vue?vue&type=style&index=0&id=c1b864d4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b864d4"]])

export default __exports__